import React from 'react';
/**
 * Componente visual de "Loading".
 *
 * Muestra un indicador de carga centrado en pantalla. Ideal para estados de espera
 * mientras se carga contenido asincrónico.
 *
 * Accesibilidad:
 * - Usa role="status" para que lectores de pantalla lo anuncien como elemento de estado.
 * - Usa aria-live="polite" para que no interrumpa el contenido actual del lector de pantalla.
 */

export default function Loading() {
  return (
    <div className="loading" role="status" aria-live="polite">
      <div className="container-loading">
        <div className="loadingIndicator" aria-hidden="true"></div>
      </div>
    </div>
  );
}